// extracted by mini-css-extract-plugin
export default {"siteFooter":"_1YyJefon2C5KMbo7QwGL-V","copyright":"_3QVTpr7CiZlqchlZvLAoCh","flair":"_1r_GvDHkbcsGRuGFUIbGhz","container":"_2H7p5A6YBcXlPTdLIuF4qY"};